import angular, { IRootElementService, IQService, IScope } from 'angular';
import { AuthService } from '../../../../services/auth/auth.service';

function mapTamanhoArquivo (tamanho) {
  const unidades = ['B', 'KB', 'MB'];
  let i = 0;
  while (tamanho >= 900 && i < unidades.length - 1) {
    tamanho /= 1024;
    i++;
  }

  return (Math.floor(tamanho * 100) / 100).toFixed(2) + ' ' + unidades[i];
}

export class ResponderController {
  /**
   *
   * @param {angular.resource.IResourceClass<any>} AtendimentoResource
   * @param {angular.resource.IResourceClass<any>} AtendimentoComentarioResource
   * @param {AuthService} Auth
   * @param {*} Upload
   * @param {IRootElementService} $element
   * @param {IQService} $q
   * @param {IScope} $scope
   * @param {string} URL_API_ATENDIMENTO
   */
  constructor(AtendimentoResource, AtendimentoComentarioResource, Auth, Upload, $element, $q, $scope, $timeout, URL_API_ATENDIMENTO) {
    "ngInject";

    this.AtendimentoResource = AtendimentoResource;
    this.AtendimentoComentarioResource = AtendimentoComentarioResource;
    this.Auth = Auth;
    this.Upload = Upload;
    this.$element = $element;
    this.$q = $q;
    this.$timeout = $timeout;
    this.$scope = $scope;
    this.URL_API_ATENDIMENTO = URL_API_ATENDIMENTO;
    this.processando = false;

    $scope.removerAnexo = (anexo) => {
      const index = $scope.anexos.findIndex((a) => a === anexo);
      $scope.anexos.splice(index, 1);
      this.validarAnexos($scope.anexos);
    }
  }

  $onInit() {
    this.submitText = this.submitText || 'RESPONDER';
    this.limpar();
    this.$element.find('.resposta').focus();
  }

  /**
   * Converte o conteúdo de uma div contenteditable para uma string
   *
   * Internamente adiciona um parágrafo na primeira linha, converte parágrafos para dois `\n` e quebras de linha para um `\n`
   *
   * @param {string} texto
   * @returns {string}
   */
  filtraTextoHTML(texto) {
    if (!texto || ('' + texto).length === 0) {
      return '';
    }

    texto = texto.replace(/^(.*?)<p>/, "<p>$1</p><p>")
                  .replace(/\<p\>\s*\<br\s*\/?\>\s*\<\/p\>/g, "<p></p>")
                  .replace(/<p>(.*?)<\/p>/g, "$1\n\n")
                  .replace(/<br\s*\/?>/g, "\n");

    return jQuery('<div>' + texto + '</div>').text();
  }

  /**
   * Retorna a quantidade de caracteres, ignorando espaços no começo e fim e novas linhas
   * @param {string} texto
   * @returns {number}
   */
  contarCaracteres(texto) {
    texto = this.filtraTextoHTML(texto).replace(/\r?\n|\r/g, '').replace(/^\s*(\S)/, '$1');

    return texto.length;
  }

  limpar() {
    this.$scope.texto = '';
    this.$scope.caracteres = 0;
    this.$scope.anexos = [];
  }

  async responder(form) {
    this.processando = true;

    var ticketData = this.ticketData;

    if (typeof(ticketData) === 'function') {
      ticketData = ticketData();

      if (ticketData === false) {
        this.processando = false;
        return;
      }
    } else if (!ticketData) {
      ticketData = this.$q.resolve();
    }

    if (!form.$valid) {
      this.processando = false;
      return;
    }

    this.validarAnexos(this.$scope.anexos);

    if (this.$scope.erroTamanhoTotal || this.$scope.anexos.some((arquivo) => arquivo.$error)) {
      this.processando = false;
      return;
    }

    let ticket;
    try {
      if (typeof (ticketData.then) === 'function') {
        ticket = await ticketData;
      } else {
        ticket = ticketData;
      }
    } catch (e) {}

    if (ticket === false) {
      this.processando = false;
      throw new Error();
    }

    try {
      const anexos = await this.enviarAnexos(this.$scope.anexos).then(undefined, undefined, (progress) => {
        this.$scope.fazendoUpload = true;
        this.processando= true;
        this.$scope.color = '#1ac095';
        this.$scope.textoProgresso = 'Enviando arquivo ' + (progress.atual + 1) + ' de ' + this.$scope.anexos.length + ' (' + mapTamanhoArquivo(progress.enviados) + ' de ' + mapTamanhoArquivo(progress.total) + ')';
        this.$scope.progresso = progress.enviados / progress.total * 100;
      });

      this.$scope.fazendoUpload = false;

      let theData;
      if (this.ticketId) {
        const novoComentario = new this.AtendimentoComentarioResource({
          ticketId: this.ticketId,
          body: this.filtraTextoHTML(form.texto.$modelValue),
          attachments: anexos.map(function (anexo) {
            return anexo.token;
          })
        });

        theData = await novoComentario.$save();
      } else {
        const novoTicket = new this.AtendimentoResource(Object.assign({
          comment: this.filtraTextoHTML(form.texto.$modelValue),
          tags: ['origem-webapp'],
          attachments: anexos.map(function (anexo) {
            return anexo.token;
          })
        }, ticket));

        theData = await novoTicket.$save();
      }

      this.limpar();
      form.$submitted = false;
      this.processando = false;

      if (typeof (this.onRespostaSucesso) === 'function') {
        this.onRespostaSucesso(theData);
      }
    } catch (err) {
      this.$scope.textoProgresso = 'Falhamos em receber os arquivos';
      if (err && typeof(err.status) !== 'undefined' && err.status <= 0) {
        this.$scope.textoProgresso = 'Falhamos em receber os arquivos devido a um erro de conexão';
      }
      this.$scope.color = '#ff7864';

      this.$timeout(() => {
        this.$scope.fazendoUpload = false;
      }, 5000);

      this.processando = false;
      throw new Error();
    }
  }

  validarAnexos(arquivos) {
    arquivos = arquivos || [];

    const tamanhoTotal = arquivos.reduce((prev, cur) => cur.size + prev, 0);

    this.$scope.erroTamanhoTotal = tamanhoTotal >= 10e6;

    arquivos.forEach((arquivo) => {
      if (arquivo.size > 7e6) {
        arquivo.$error = 'Este arquivo é muito grande. O tamanho máximo é 7 MB.';
      }
    });
  }

  enviarAnexos(arquivos) {
    const deferred = this.$q.defer();
    let contagem = arquivos ? arquivos.length : 0;
    let atual = 0;
    let totalEnviado = 0;
    let tamanhoTotal = 0;

    const enviaArquivo = async (arquivo, anexos) => {
      let ultimoByte = 0;
      const uploadUrl = this.URL_API_ATENDIMENTO + '/atendimentos' + (this.ticketId ? '/' + this.ticketId : '') + '/anexos';

      return this.Upload.upload({
        url: uploadUrl,
        data: {
          anexo: arquivo
        },
        headers: {
          'Authorization': this.Auth.getToken()
        }
      }).then(function (dados) {
        anexos.push(dados.data);

        if (--contagem === 0) {
          deferred.resolve(anexos);
        } else {
          return enviaArquivo(arquivos[++atual], anexos);
        }
      }, function (err) {
        deferred.reject(err);
      }, function (progress) {
        totalEnviado += progress.loaded - ultimoByte;
        ultimoByte = progress.loaded;
        const data = {
          atual: atual,
          enviados: totalEnviado,
          total: tamanhoTotal,
        };

        deferred.notify(data);
      });
    };

    if (!contagem || contagem === 0) {
      deferred.resolve([]);
      return deferred.promise;
    }

    tamanhoTotal = arquivos.reduce((prev, cur) => cur.size + prev, 0);

    enviaArquivo(arquivos[atual], []);

    return deferred.promise;
  }
}

/**
 * @type {angular.IComponentOptions}
 */
export const ResponderComponent = {
  controller: ResponderController,
  controllerAs: '$ctrl',
  template: require('./responder.component.html'),
  bindings: {
    ticketId: '<',
    ticketData: '<',
    onRespostaSucesso: '<',
    submitText: '@',
  }
}
